import { GetCaptchaActionEnabled, RcmReCaptcha2PublicConfig } from '../types';

/**
 * Create a function that will return whether captcha is enabled for a given action.
 *
 * @param cfg Configuration from which decisions should derived.
 */
const createGetCaptchaActionEnabled =
  (cfg: RcmReCaptcha2PublicConfig): GetCaptchaActionEnabled =>
  (action) => {
    if (cfg.enabled !== undefined && !cfg.enabled) {
      return false;
    }

    if (cfg.actions === undefined) {
      return true;
    }

    if (cfg.actions[action] === undefined) {
      return true;
    }

    if (cfg.actions[action].enabled === undefined) {
      return true;
    }

    if (!cfg.actions[action].enabled) {
      return false;
    }

    return true;
  };

export default createGetCaptchaActionEnabled;
